import React from 'react';
import { motion } from 'framer-motion';
const pillars = [{
  numeral: 'I',
  title: 'The Iron Wall',
  quote: 'A voluntary agreement is unattainable... Zionism must either be stopped or proceed regardless of the native population.',
  description: 'Peace through strength. Jabotinsky argued that only when adversaries recognize they cannot destroy Israel—when they face an "Iron Wall" of Jewish defense—will genuine, lasting peace become possible.'
}, {
  numeral: 'II',
  title: 'Liberal Nationalism',
  quote: 'Every man is a king.',
  description: 'A synthesis of national self-determination and individual rights. He believed deeply in democratic institutions, free markets, and the absolute equality of all citizens, asserting that every minority deserves cultural autonomy.'
}, {
  numeral: 'III',
  title: 'Hadar (Dignity)',
  quote: 'Hadar means outward beauty, respect, self-reliance, and politeness.',
  description: 'A philosophy of personal and national dignity. It demands pride without arrogance, chivalry, and self-respect as the foundation of a healthy national character after centuries of exile.'
}, {
  numeral: 'IV',
  title: 'Self-Defense',
  quote: 'Better to have a gun and not need it, than to need it and not have it.',
  description: 'The Jewish people must be capable of defending themselves. He rejected reliance on the goodwill of others, insisting on Jewish military preparedness as a moral imperative.'
}, {
  numeral: 'V',
  title: 'Monism',
  quote: 'One flag, one ideal.',
  description: 'Total dedication to the national cause. Jabotinsky rejected the blending of Zionism with other ideologies like socialism, demanding clarity of purpose and no half-measures in the pursuit of a Jewish state.'
}, {
  numeral: 'VI',
  title: 'The Evacuation',
  quote: 'Eliminate the diaspora, or the diaspora will surely eliminate you.',
  description: "Jabotinsky's most prophetic and tragic stance. Throughout the 1930s he urged the mass evacuation of European Jewry to Palestine, warning of an impending catastrophe. Dismissed as alarmist by mainstream leaders, his warnings proved devastatingly prescient."
}];
export function PhilosophySection() {
  return <section id="philosophy" className="py-24 md:py-32 bg-[#1A1A1A] text-[#F5F0E8]" data-id="element-159">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16 md:mb-24 max-w-3xl" data-id="element-161">
          <h2 className="text-sm font-medium tracking-[0.2em] text-[#B8860B] uppercase mb-4" data-id="element-162">
            Core Philosophy
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-163">
            The Pillars of His Thought
          </h3>
          <p className="text-lg text-[#F5F0E8]/70 leading-relaxed" data-id="element-164">
            Six principles that defined a movement and shaped a nation's
            founding philosophy.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-165">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative bg-[#242424] border-t-2 border-[#B8860B] p-8 md:p-10 transition-all duration-500 flex flex-col h-full group hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#B8860B]/10" data-id="element-166">
              {/* Decorative Roman Numeral Watermark */}
              <div className="absolute top-4 right-6 text-7xl font-serif text-[#B8860B]/10 select-none pointer-events-none transition-colors duration-500 group-hover:text-[#B8860B]/20" data-id="element-167">
                {pillar.numeral}
              </div>

              <div className="relative z-10 flex flex-col h-full" data-id="element-168">
                <h4 className="text-2xl font-serif font-semibold text-[#F5F0E8] mb-8 pr-12" data-id="element-169">
                  {pillar.title}
                </h4>

                <blockquote className="text-[#B8860B] font-serif italic mb-8 text-xl border-l-2 border-[#B8860B] pl-5 leading-relaxed" data-id="element-170">
                  "{pillar.quote}"
                </blockquote>

                <p className="text-[#F5F0E8]/70 leading-relaxed mt-auto" data-id="element-171">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}